import { render, staticRenderFns } from "./NewFunding.vue?vue&type=template&id=140f0cd6&scoped=true"
import script from "./NewFunding.vue?vue&type=script&lang=js"
export * from "./NewFunding.vue?vue&type=script&lang=js"
import style0 from "./NewFunding.vue?vue&type=style&index=0&id=140f0cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140f0cd6",
  null
  
)

export default component.exports